import styles from './App.module.css';
import Hero from './helper/Hero.js';
import Navbar from './helper/Navbar.js'
import About from './components/About.js'
import Experience from './components/Experience.js'
import Education from './components/Education.js'
import Projects from './components/Projects.js'
import Skills from './components/Skills.js'
import Contact from './components/Contact.js'
import Footer from './helper/Footer.js'




function App() {
  return (
    <div className={styles.App}>
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Education />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
